// extracted by mini-css-extract-plugin
module.exports = {"mobile":"_2BhJR","root":"_3kDqV","onImage":"_2ELTy"};